import React from 'react';
// import { ChevronRight, Phone, Mail } from 'lucide-react';


// images
import Purification from "../assests/home/air 1.png";
import Filtration from "../assests/home/filtration.png";
import Versatile from "../assests/home/split.png";

import aop from "../assests/home/aop.png";
import cbr from "../assests/home/cbr.png";
import ultrasorb from "../assests/home/ultrasorb.png";

import Beverages from "../assests/home/Beverages.png";
import commercial from "../assests/home/commercial.png";
import Material from "../assests/home/Material.png";
import Transportation from "../assests/home/Transportation.png";
import water from "../assests/home/water.png";
import HeroCarousel from '../components/HeroCarousel';
import ClientCarouselDemo from '../components/ClientCarousel2';
import { Link } from 'react-router-dom';
import { useRef, useEffect, useState } from 'react';
import Newsletter from '../components/Newsletter';
const clientLogos2 = [
    { name: "Microsoft", src: "/api/placeholder/120/60", alt: "Microsoft Logo" },
    { name: "Google", src: "/api/placeholder/120/60", alt: "Google Logo" },
    { name: "Netflix", src: "/api/placeholder/120/60", alt: "Netflix Logo" },
    { name: "Tesla", src: "/api/placeholder/120/60", alt: "Tesla Logo" },
    { name: "Samsung", src: "/api/placeholder/120/60", alt: "Samsung Logo" },
    { name: "Adobe", src: "/api/placeholder/120/60", alt: "Adobe Logo" }
];

const UltraPureLanding = () => {

    const videoRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect(); // Stop observing after it enters
                }
            },
            {
                root: null,
                rootMargin: "0px",
                threshold: 0.5, // Trigger when 50% of video is visible
            }
        );

        if (videoRef.current) {
            observer.observe(videoRef.current);
        }

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        if (isVisible && videoRef.current) {
            videoRef.current.play().catch(() => { }); // catch autoplay errors silently
        }
    }, [isVisible]);

    return (
        <div className="min-h-screen bg-white">
            {/* Header */}
            <HeroCarousel />

            {/* Why Choose Ultrapure */}
            <section className="bg-[#1C97D4;] py-16 lg:py-24">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h2 className="text-3xl lg:text-6xl font-bold text-white mb-8">Why Choose Ultrapure</h2>
                    <p className="text-[16px] lg:text-[20px] text-white mb-8 max-w-5xl mx-auto">
                        As a need-based manufacturer, we specialize in delivering customized solutions designed around each client’s specific requirements—earning us a strong reputation and a loyal customer base. With offices in Delhi, Mumbai, and Bengaluru, we are well-positioned to serve clients across India.
                    </p>
                    <Link to='/about-us'>
                        <button className="bg-white text-[#1C97D4;] px-12 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors">
                            Learn More
                        </button></Link>
                </div>
            </section>

            {/* Hero Section */}
            <section className="relative bg-[#F5F6F8] py-12 lg:py-20">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                        <div>
                            <h2 className="text-3xl lg:text-4xl font-semibold text-[#8B8B8B] mb-6 " >Proven Air Purifying Technology</h2>
                            <p className="text-[#8B8B8B] text-lg lg:text-xl ultrapure_text">
                                Ultrapure understands air purification standards around critical manufacturing and laboratories. With extensive client requirements and technology capabilities, we deploy powerful filtration methods that neutralize viruses, bacteria, odors and mites. Ultrapure provides trusted cleanliness while eliminating harmful and enhanced indoor air quality.
                            </p>
                        </div>
                        <div className="relative">
                            <video
                                ref={videoRef}
                                width="384" // same as w-96
                                height="288" // same as h-72
                                className="w-auto h-76 object-cover rounded-lg shadow-lg m-auto"
                                muted
                                loop
                                playsInline
                                preload="none"
                                controls={true}
                            >
                                {isVisible && (
                                    <source
                                        src="./Proven Air.mp4"
                                        type="video/mp4"
                                    />
                                )}
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </div>
                </div>
            </section>


            {/* Proven Air Purifying Technology */}
            <section className="py-4 lg:py-10 bg-[#FCFCFC]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        <div className="text-center">
                            <div className="w-18 h-18 rounded-full flex items-center justify-center mx-auto mb-4">
                                <img src={Purification} />
                            </div>
                            <h3 className="mb-2 mini_text_head text-xl">Purification Technologies</h3>
                            <p className=" mini_text_font text-center">Ultrapure utilizes cutting-edge innovations in air purification to offer highly effective and efficient solutions. Our technologies undergo rigorous testing and certification by leading labs, ensuring top-quality air purification for your environment.</p>
                        </div>
                        <div className="text-center">
                            <div className="w-18 h-18 rounded-full flex items-center justify-center mx-auto mb-4">
                                <img src={Filtration} />
                            </div>
                            <h3 className="mb-2 mini_text_head text-xl">Advanced Filtration Systems</h3>
                            <p className=" mini_text_font text-center">Ultrapure’s advanced filtration systems capture particles, eliminate microbes, and neutralize gases and odors. Our custom filters target specific pollutants, ensuring cleaner air in commercial and residential spaces.</p>
                        </div>
                        <div className="text-center">
                            <div className="w-18 h-18 rounded-full flex items-center justify-center mx-auto mb-4">
                                <img src={Versatile} />
                            </div>
                            <h3 className="mb-2 mini_text_head text-xl">Versatile Applications</h3>
                            <p className="mini_text_font text-center">Ultrapure purifiers are designed for diverse industries and environments. Whether in hospitals, office buildings, or residential spaces, our solutions address the specific air quality challenges unique to each sector.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Air Purification Solutions */}
            <section className="py-8 lg:pt-10 m-auto">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h2 className="text-4xl md:text-3xl lg:text-6xl  ultrapure_heading md-8 lg:mb-12">
                        Explore Our Air Purification Solutions
                    </h2>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch">
                        {/* CARD 1 */}
                        <Link to="/aop">
                            <div className="bg-gray-100 flex flex-col shadow-lg hover:shadow-xl rounded-2xl h-full">
                                <img
                                    src={aop}
                                    alt="Advanced Oxidation Plasma"
                                    className="w-full h-72 object-contain bg-[#FCFCFC] py-6  border-top-30"
                                />
                                <div className="bg-[#F0EDED] p-8 flex-grow flex flex-col border-bottom-30">
                                    <h3 className="text-xl font-light text-[#313131] mb-2">
                                        Advanced Oxidation Plasma (AOP) Cell
                                    </h3>
                                    <p className="text-gray-600 text-sm ">
                                        <span className='text-[#1C97D4]'>&ndash;</span>
                                        Easy to retrofit with existing or new system<br />
                                        <span className='text-[#1C97D4]'>&ndash;</span>  Requires zero maintenance<br />
                                        <span className='text-[#1C97D4]'>&ndash;</span>  Ozone free system<br />
                                        <span className='text-[#1C97D4]'>&ndash;</span>  Greener and sustainable solution
                                    </p>
                                </div>
                            </div>
                        </Link>

                        {/* CARD 2 */}
                        <Link to="/cf">
                            <div className="bg-gray-100 flex flex-col shadow-lg hover:shadow-xl rounded-2xl h-full">
                                <img
                                    src={cbr}
                                    alt="Chemical, Biological, and Radiological"
                                    className="w-full h-72 object-contain bg-[#FCFCFC] py-6 border-top-30"
                                />
                                <div className="bg-[#F0EDED] p-8 flex-grow flex flex-col border-bottom-30">
                                    <h3 className="text-xl font-light text-[#313131] mb-2">
                                        Chemical, Biological, and Radiological (CBR) Filter
                                    </h3>
                                    <p className="text-gray-600 text-sm ">
                                        <span className='text-[#1C97D4]'>&ndash;</span>  Easily installed in the existing HVAC&R system.<br />
                                        <span className='text-[#1C97D4]'>&ndash;</span>  Flexible design & cost effective solution<br />
                                        <span className='text-[#1C97D4]'>&ndash;</span>  Very low pressure drop & energy consumption
                                    </p>
                                </div>
                            </div>
                        </Link>
                        <Link to="/ucm">
                            {/* CARD 3 */}
                            <div className="bg-gray-100 flex flex-col shadow-lg hover:shadow-xl rounded-2xl h-full">
                                <img
                                    src={ultrasorb}
                                    alt="UltraSORB Media"
                                    className="w-full h-72 object-contain bg-[#FCFCFC] py-6 border-top-30"
                                />
                                <div className="bg-[#F0EDED] p-8 flex-grow flex flex-col border-bottom-30">
                                    <h3 className="text-xl font-light text-[#313131] mb-2">
                                        ultraSORB MediaultraSORB <br></br> Media
                                    </h3>
                                    <p className="text-gray-600 text-sm ">
                                        <span className='text-[#1C97D4]'>&ndash;</span>  No bypass<br />
                                        <span className='text-[#1C97D4]'>&ndash;</span>  Full optimization<br />
                                        <span className='text-[#1C97D4]'>&ndash;</span>  Low pressure drop<br />
                                        <span className='text-[#1C97D4]'>&ndash;</span>  Turbulent flow
                                    </p>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
            </section>

            {/* Clean Air Solutions for Every Industry */}
            <section className="py-5 lg:pt-20 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h2 className="text-4xl md:text-3xl lg:text-6xl ultrapure_heading mb-4">Clean Air Solutions for Every Industry</h2>
                    <p className="text-lg lg:text-2xl text-[#8B8B8B] text-center mb-5 lg:mb-12 font-thin">Flexible, high-efficiency solutions built around the specific needs of your industry.</p>

                    {/* Mobile: Single column, Desktop: Custom grid layout */}
                    <div className="flex flex-col gap-5 lg:gap-12">

                        {/* Top 3 cards - Always in a row on desktop, column on mobile */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-12 justify-center">
                            <Link to="/commercial">
                                <div className="text-center bg-[#FCFCFC] p-5 lg:px-6 pt-6 pb-2 rounded-3xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                                    <img
                                        src={commercial}
                                        alt="Commercial & Public Building"
                                        className="w-full h-auto object-cover rounded-md mb-4"
                                    />
                                    <h3 className="text-lg lg:text-xl font-thin text-[#8b8b8b]">Commercial & <br /> Public Building</h3>
                                </div>
                            </Link>

                            <Link to="/industrial">
                                <div className="text-center bg-[#FCFCFC] p-5 lg:px-6 pt-6 pb-2 rounded-3xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                                    <img
                                        src={Transportation}
                                        alt="Industrial Transportation"
                                        className="w-full h-auto object-cover rounded-md mb-4"
                                    />
                                    <h3 className="text-lg lg:text-xl font-thin text-[#8b8b8b]">Industrial/ <br /> Transportation</h3>
                                </div>
                            </Link>
                            <Link to="/food">
                                <div className="text-center bg-[#FCFCFC] p-5 lg:px-6 pt-6 pb-2 rounded-3xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                                    <img
                                        src={Beverages}
                                        alt="Food & Beverages"
                                        className="w-full h-auto object-cover rounded-md mb-4"
                                    />
                                    <h3 className="text-lg lg:text-xl font-thin text-[#8b8b8b]">Food & <br /> Beverages</h3>
                                </div>
                            </Link>
                        </div>

                        {/* Bottom 2 cards - Centered on desktop, continue column on mobile */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-12 md:max-w-4xl md:mx-auto">
                            <Link to="/material">
                                <div className="text-center bg-[#FCFCFC] p-5 lg:px-6 pt-6 pb-2 rounded-3xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                                    <img
                                        src={Material}
                                        alt="Material Processing"
                                        className="w-full h-auto object-cover rounded-md mb-4"
                                    />
                                    <h3 className="text-lg lg:text-xl font-thin text-[#8b8b8b]">Material <br /> Processing</h3>
                                </div>
                            </Link>

                            <Link to="/waste">
                                <div className="text-center bg-[#FCFCFC] p-5 lg:px-6 pt-6 pb-2 rounded-3xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                                    <img
                                        src={water}
                                        alt="Water Waste Management"
                                        className="w-full h-auto object-cover rounded-md mb-4"
                                    />
                                    <h3 className="text-lg lg:text-xl font-thin text-[#8b8b8b]">Water <br /> Waste</h3>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

            <ClientCarouselDemo
                title="Trusted Partners"
                logos={clientLogos2}
                autoPlay={true}
                autoPlayInterval={4000}
            />



           {/* <section className="bg-gray-50 py-12 lg:py-10">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex flex-col lg:flex-row min-h-[400px]">

                        <div className="w-full lg:w-1/2 flex items-center justify-center p-2 lg:p-12 order-1 lg:order-2">
                            <div className="max-w-lg text-center lg:text-left">

                                <h2 className="text-3xl lg:text-5xl font-normal text-gray-800 mb-6 lg:mb-8">
                                    Need Assistance?
                                </h2>

                                <p className="text-gray-500 text-base lg:text-lg leading-relaxed mb-8 lg:mb-10 font-thin">
                                    Whether you're exploring clean air solutions or need support for an existing installation, our team is here to help. Let's create a healthier environment—together.
                                </p>

                                <Link to="/contact">
                                    <button className="bg-[#1C97D4] hover:bg-blue-600 text-white font-semibold px-10 py-3 rounded-lg text-base lg:text-lg transition-all duration-300 transform hover:scale-105 hover:shadow-xl shadow-lg">
                                        SUPPORT
                                    </button>
                                </Link>
                            </div>
                        </div>

                        <div className="w-full lg:w-1/2 flex items-center justify-center p-4 lg:p-12 order-2 lg:order-1">
                            <div className="flex flex-col space-y-6 text-center lg:text-left w-full max-w-md">

                                <div className="flex items-center justify-center lg:justify-start space-x-3">
                                    <img src="./phone-call 1.svg" width={25} alt="Phone Icon" />
                                    <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-2">
                                        <a
                                            href="tel:1800110050"
                                            className="text-base sm:text-xl lg:text-2xl text-gray-800 font-medium hover:underline"
                                        >
                                            1800-1100-50
                                        </a>
                                        <span className="text-gray-500 text-sm sm:text-base lg:text-lg">(Toll Free)</span>
                                    </div>
                                </div>

                                <div className="flex items-center justify-center lg:justify-start space-x-3">
                                    <img src="./mail 1.svg" width={25} alt="Mail Icon" />
                                    <a
                                        href="mailto:info@ultrapureindia.in"
                                        className="text-base sm:text-xl lg:text-2xl text-gray-800 font-medium break-words hover:underline"
                                    >
                                        info@ultrapureindia.in
                                    </a>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </section>  */}

            <Newsletter/>
        </div>
    );
};

export default UltraPureLanding;